import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { getUploadedUGCContentListFailure, getUploadedUGCContentListSuccess } from '../../actions/CreateCampaignActions/getUploadedUGCContentListActions';

function* getUploadedUGCContentList({ payload }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.getUploadedUGCContentList,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_UPLOADED_UGC_CONTENT_LIST_SUCCESS status :", response.data.status);
        console.log("GET_UPLOADED_UGC_CONTENT_LIST_SUCCESS data :", response.data.response);
        console.log("GET_UPLOADED_UGC_CONTENT_LIST_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getUploadedUGCContentListSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("GET_UPLOADED_UGC_CONTENT_LIST_FAILURE status :", error?.response?.status);
        console.log("GET_UPLOADED_UGC_CONTENT_LIST_FAILURE data:", error?.response?.data);
        console.log("GET_UPLOADED_UGC_CONTENT_LIST_FAILURE error :", error);
        console.log('====================================');
        yield put(getUploadedUGCContentListFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getUploadedUGCContentListSaga() {
    yield takeLatest(actionTypes.GET_UPLOADED_UGC_CONTENT_LIST_REQUEST, getUploadedUGCContentList);
}

export default getUploadedUGCContentListSaga;